import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { stats, heroImages } from '../mock';

const AboutAshram = () => {
  return (
    <section id="about" className="relative py-20 md:py-28 bg-cream overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Left: image with organic mask */}
          <div className="relative">
            <div className="relative w-full max-w-[520px] mx-auto">
              <div
                className="relative overflow-hidden aspect-[4/5] w-full"
                style={{
                  borderRadius: '50% 50% 50% 50% / 40% 40% 60% 60%',
                  boxShadow: '0 30px 60px -20px rgba(74,23,33,0.25)'
                }}
              >
                <img src={heroImages.ashram} alt="Ashram" className="w-full h-full object-cover" />
              </div>
              {/* Floating small decor */}
              <div className="absolute -top-6 -right-4 w-24 h-24 rounded-full opacity-70" style={{ background: 'radial-gradient(circle,#F7D5DA,transparent 70%)' }} />
              <div className="absolute -bottom-6 -left-4 w-32 h-32 rounded-full opacity-60" style={{ background: 'radial-gradient(circle,#EEB1BA,transparent 70%)' }} />
            </div>
          </div>

          {/* Right: text */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 rounded-full flex items-center justify-center bg-rose-soft">
                <span className="w-3 h-3 rounded-full bg-mahogany" />
              </span>
              <span className="eyebrow">About Ashram</span>
            </div>
            <h2 className="font-serif-display text-burgundy text-4xl md:text-5xl leading-[1.08]">
              A Holistic Journey
              <span className="block font-italic-display text-rose-italic mt-1">Back to Yourself</span>
            </h2>
            <p className="mt-6 text-burgundy/85 leading-relaxed max-w-xl">
              In sanskrit <em>Tapa</em> means spiritual practice and <em>bana</em> means forest, Tapoban literally translates into a forest of spiritual practise and it is exactly so! Inspired by the vision of the enlightened mystic Osho, Tapoban is a modern day hermitage and an international growth center located in the heart of the lush Nagarjuna hills inside the Shivapuri Wildlife Reserve forest. Based on the foothills of the great Himalayas, Tapoban is also an ancient Buddhafield where the great Buddhist master Nagarjuna meditated and attained ultimate liberation.
            </p>
            <a href="#about-osho" className="pill-btn mt-8">More about Us <ArrowUpRight className="w-4 h-4" /></a>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 grid md:grid-cols-3 gap-10 md:gap-6 relative">
          {stats.map((s, i) => (
            <div key={i} className={`px-4 md:px-8 ${i !== 0 ? 'md:border-l border-rose/60' : ''}`}>
              <div className="font-serif-display text-burgundy text-6xl md:text-7xl leading-none flex items-baseline gap-2 flex-wrap">
                <span>{s.number}</span>
                {s.unit && <span className="font-italic-display text-4xl md:text-5xl text-burgundy/90">{s.unit}</span>}
              </div>
              <p className="mt-4 text-burgundy/80 max-w-xs leading-relaxed">{s.description}</p>
              {s.link && (
                <Link to={s.link} data-testid="ashram-cta-link"
                  className="mt-4 inline-flex items-center gap-1.5 text-rose-italic font-medium hover:text-burgundy transition-colors">
                  {s.linkLabel || 'Learn more'} <ArrowUpRight className="w-4 h-4" />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutAshram;
